import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { EnvironmentService } from "./environment.service";

export interface MarshRequestOptions {
  observe?: "body";
  reportProgress?: boolean;
  responseType?: "json";
  withCredentials?: boolean;
}

/**
 * HTTP client for Marsh insurance broker API.
 * Base URL from environment: marsh_api.url
 */
@Injectable({
  providedIn: "root",
})
export class HttpMarshClientService {
  private authHeaders: { headers: HttpHeaders } | null = null;

  constructor(private http: HttpClient, private environmentService: EnvironmentService) {}

  private get endpoint(): string {
    return this.environmentService.get("marsh_api.url") || "";
  }

  private ensureAuthHeaders(): { headers: HttpHeaders } {
    if (!this.authHeaders) {
      const access_token = localStorage.getItem("access_token");
      this.authHeaders = access_token
        ? {
            headers: new HttpHeaders({
              Authorization: "Bearer " + access_token,
            }),
          }
        : { headers: new HttpHeaders() };
    }
    return this.authHeaders;
  }

  public post(url: string, body: unknown, options: MarshRequestOptions = {}): Observable<unknown> {
    const allOpts = { ...this.ensureAuthHeaders(), ...options };
    return this.http.post(this.endpoint + url, body, allOpts);
  }
}
